import { HOW_IT_WORKS } from "@/lib/data";

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" id="how-it-works" className="section-pad bg-navy text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "32px 32px"
      }} />
      <div className="container-pad mx-auto max-w-7xl relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-medium text-teal-300">
            <span className="w-8 h-px bg-teal-300" />
            How It Works
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-white tracking-tight mt-5 leading-[1.15]">
            From request to arrival — <span className="font-bold text-teal-300">five simple steps.</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
          {HOW_IT_WORKS.map((step, i) => (
            <div key={step.step} className="relative" data-testid={`step-${step.step}`}>
              <div className="relative bg-white/[0.04] hover:bg-white/[0.08] transition rounded-2xl p-6 border border-white/10 h-full">
                <div className="font-heading text-5xl font-bold text-teal-300/40">{step.step}</div>
                <h3 className="font-heading text-lg font-semibold text-white mt-4">{step.title}</h3>
                <p className="text-white/65 text-sm mt-2 leading-relaxed">{step.body}</p>
              </div>
              {i < HOW_IT_WORKS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-teal-300/40" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
